module.exports = __webpack_public_path__ + "img/image1.96843a1e.jpg";